export default "__VITE_ASSET__a326c8c5__"